import { render } from "./providerCreate.vue?vue&type=template&id=3e84b136&scoped=true"
import script from "./providerCreate.vue?vue&type=script&lang=js"
export * from "./providerCreate.vue?vue&type=script&lang=js"

import "./providerCreate.vue?vue&type=style&index=0&id=3e84b136&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e84b136"]])

export default __exports__